const DATES_OF_WEEK = [
  {
    label: 'CN',
    isChecked: true,
    value: 1,
  },
  {
    label: 'T2',
    isChecked: true,
    value: 2,
  },
  {
    label: 'T3',
    isChecked: true,
    value: 3,
  },
  {
    label: 'T4',
    isChecked: true,
    value: 4,
  },
  {
    label: 'T5',
    isChecked: true,
    value: 5,
  },
  {
    label: 'T6',
    isChecked: true,
    value: 6,
  },
  {
    label: 'T7',
    isChecked: true,
    value: 7,
  },
];

export default DATES_OF_WEEK;
